import { Component, HostBinding, Input } from '@angular/core';
import { TabsComponent } from '../tabs.component';

@Component({
  selector: 'app-tab-option',
  template: `
    <button
      type="button"
      class="tab-btn"
      [class.active]="parent?.activeIndex() === index"
      role="tab"
      [attr.aria-selected]="parent?.activeIndex() === index"
      (click)="parent?.selectIndex(index)"
    >
      <ng-content></ng-content>
    </button>
  `,
  styles: [
    `
      .tab-btn {
        appearance: none;
        border: 0;
        background: transparent;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 12px 8px;
        color: var(--color-gray-500);
        text-align: center;
      }
      .tab-btn.active {
        color: var(--secondary-dark);
        font-weight: 700;
      }
      .tab-btn:focus-visible {
        outline: 2px solid var(--secondary-dark);
        outline-offset: 2px;
      }
    `,
  ],
})
export class TabOptionComponent {
  @Input() value?: string; // optional, for your own use
  index = 0;
  parent?: TabsComponent;

  // make each option consume equal width
  @HostBinding('style.flex') flex = '1 1 0%'; // each option takes equal width
  @HostBinding('style.display') display = 'flex';
}
